import { Button, Input, LoaderFullPage } from '@alejandro3c/icy-react-ui';
import { Controller } from 'react-hook-form';
import { Link } from 'react-router-dom';
import googleLogo from '@/assets/googleLogo.webp';
import { useLogin } from '../hooks/useLogin';

export default function Login() {
	const { control, loading, error, onSubmit, handleGoogleLogin } = useLogin();

	return (
		<>
			<div className="flex items-center justify-center min-h-screen bg-gray-100">
				<div className="bg-white p-6 rounded-lg shadow-lg w-120">
					<h2 className="text-2xl font-bold mb-4 text-center">Inicio de sesión</h2>
					{error && <p className="text-red-500 text-sm mb-4">{error}</p>}
					<form onSubmit={onSubmit} className="space-y-4">
						<Controller
							name="email"
							control={control}
							render={({ field }) => (
								<Input type="email" placeholder="Email" value={field.value} onChange={field.onChange} required />
							)}
						/>

						<Controller
							name="password"
							control={control}
							render={({ field }) => (
								<Input
									type="password"
									placeholder="Contraseña"
									value={field.value}
									onChange={field.onChange}
									required
								/>
							)}
						/>

						<Button variant="solid" className="w-full py-2" type="submit">
							Iniciar sesión
						</Button>

						<Button
							type="button"
							variant="subtle"
							className="w-full py-2 flex items-center justify-center"
							onClick={handleGoogleLogin}
						>
							<img src={googleLogo} alt="Google" className="w-4 h-4 mr-2" />
							<span className="text-center">Iniciar sesión con Google</span>
						</Button>

						<div className="text-center mt-4">
							<Link
								to="/privacy-policy"
								className="text-sm text-gray-500 hover:text-gray-700 hover:underline"
							>
								Política de privacidad
							</Link>
						</div>
					</form>
				</div>
			</div>
			{loading && <LoaderFullPage />}
		</>
	);
}
